module.exports = __webpack_public_path__ + "img/tcv_driving.7fd6fd7b.svg";